import config from '../share/config';

// ドロップダウンアイテム定数値
export const TAP_START = { type: 'start', label: 'message.menu_label_move_start' };
export const TAP_VERSION_INFO = { type: 'version_info', label: 'message.label_detailed_version_information' };
export const TAP_USER_INFO = { type: 'user_info', label: 'message.menu_label_user_Info' };
export const TAP_LANGUAGE = { type: 'language', label: 'message.menu_label_language' };
export const TAP_UNIT = { type: 'unit', label: 'message.menu_label_unit' };
export const TAP_PERSONAL_DATA = { type: 'personal_data', label: 'message.menu_label_personal_data' };
export const TAP_USER_TERMS = { type: 'user_terms', label: 'message.menu_label_terms' };
export const TAP_DIVIDER = { type: 'divider', label: '' };
export const TAP_LOG_OUT = { type: 'logout', label: 'message.menu_label_signout' };
export const TAP_TECH_MANUAL = { type: 'manual', label: 'message.menu_label_tech_manual' };
export const TAP_REPRO_FILE_DOWNLOAD = { type: 'repro_file_download', label: 'message.menu_repro_file_download' };
export const TAP_TO_PROJECT = { type: 'to_project', label: 'message.menu_vehicle_to_project' };
export const TAP_TO_MENU = { type: 'to_menu', label: 'message.menu_project_to_vehicle' };

// バージョン情報の表示
export const CONVERT_TO_DISPLAY_NAME = {
  cc_info: "Cloud Connector",
  ...config.SYSTEM_MODULES
};
